import Joi from 'joi';

const custom = Joi.extend({
  messages: {
    maxLength: 'Comentario supera los 250 caracteres',
    undefinedComment: 'Comentario requerido',
  },
  type: 'comment',
  rules: {
    validateComment: {
      validate(value, helpers) {
        if (!value.length) return helpers.error('undefinedComment');
        else if (value.length > 255) return helpers.error('maxLength');
        else return true;
      },
    },
  },
});

export const schema = Joi.object({
  newAddress: Joi.string()
    .min(10)
    .error(new Error('Nueva dirección es requerida')),
  comment: custom.comment().validateComment(),
});
